import React, { useEffect } from "react";
import Routes from "./Routes";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from 'sonner';
import { CookieConsentBanner } from "./components/CookieConsentBanner";

function App() {
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (saved === 'dark' || (!saved && prefersDark)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors={false} theme="light" closeButton expand={false} />
      <CookieConsentBanner />
      <Routes />
    </BrowserRouter>
  );
}

export default App;
